import * as R from "ramda";

export const fileIsValid = function (apiResponse, file) {
  if (apiResponse === null || apiResponse === undefined) {
    return true;
  }
  const error = R.find(
    (fileError) => fileError.filename === file.name,
    apiResponse.files
  );
  return error.is_valid;
};

export const getFileErrors = function (apiResponse, file) {
  if (apiResponse === null || apiResponse === undefined) {
    return [];
  }
  const error = R.find(
    (fileError) => fileError.filename === file.name,
    apiResponse.files
  );
  return !!error ? error.validation_error : [];
};

export const hasFileErrors = function (apiResponse) {
  return R.not(
    R.propOr(true, "is_valid_size", apiResponse) &&
      R.propOr(true, "files_are_valid", apiResponse)
  );
};
